/**
 * Imitacja enuma zawierajaca wszyste dostepne aktywnosci uzytkownika
 */
export const Activity = {

  // NAVIGATION
  NAV_HOME: 'NAV_HOME', //
  NAV_SETTINGS: 'NAV_SETTINGS', //
  NAV_LIST_USERS: 'NAV_LIST_USERS', //
  NAV_LIST_RESTAURANTS: 'NAV_LIST_RESTAURANTS', //
  NAV_LIST_NETWORKS: 'NAV_LIST_NETWORKS', //
  NAV_LIST_CONNECTIONS: 'NAV_LIST_CONNECTIONS', //
  NAV_LIST_TRANSACTIONS: 'NAV_LIST_TRANSACTIONS', //

  LIST_USERS: 'LIST_USERS', //
  ADD_USER: 'ADD_USER', //
  EDIT_USER: 'EDIT_USER', //
  DELETE_USER: 'DELETE_USER', //

  EDIT_USER_CREDENTIALS: 'EDIT_USER_CREDENTIALS', //

  LIST_RESTAURANTS: 'LIST_RESTAURANTS', //
  ADD_RESTAURANT: 'ADD_RESTAURANT', //
  EDIT_RESTAURANT: 'EDIT_RESTAURANT', //
  DELETE_RESTAURANT: 'DELETE_RESTAURANT', //

  LIST_NETWORKS: 'LIST_NETWORKS', //
  ADD_NETWORK: 'ADD_NETWORK', //
  EDIT_NETWORK: 'EDIT_NETWORK', //
  DELETE_NETWORK: 'DELETE_NETWORK', //

  LIST_GLOBAL_PARAMS: 'LIST_GLOBAL_PARAMS', //
	EDIT_GLOBAL_PARAMS: 'EDIT_GLOBAL_PARAMS', //

  LIST_CONNECTIONS: 'LIST_CONNECTIONS', //

  LIST_ADMIN_CONNECTIONS: 'LIST_ADMIN_CONNECTIONS', //

  SERVER_INFO: 'SERVER_INFO', //

}

/**
 * Imitacja enuma zawierajaca wszyste dostepne role uzytkownika
 */
export const UserRole = {

  ROLE_ADMIN: 1,//

  ROLE_SERVICE: 2, //
  ROLE_MANAGER: 3, //
  ROLE_POS: 10, //

}

/**
 * Sprawdza czy zalogowany uzytkonik ma dostepna podana aktywnosc
 * 
 * @param {*} authenticatedUser zalogowany uzytkownik
 * 
 * @param {*} activity aktywnosc uzytkownika jaka sprawdzamy
 */
export const checkUserActivity = (authenticatedUser, activity) => {

  //sprawdzamy czy mamy zalogowanego uzytkownika
  if (authenticatedUser) {
    //sprawdzamy czy uzytkownik ma podana akywnosc
    return authenticatedUser.activities.includes(activity);
  }

  return false;

}

/**
 * Sprawdza czy zalogowany uzytkownik ma dostepna podana role
 * 
 * @param {*} authenticatedUser zalogowany uzytkownik
 * 
 * @param {*} userRole rola uzytkownika jaka sprawdzamy
 */
export const checkUserRole = (authenticatedUser, userRole) => {

  //sprawdzamy czy mamy zalogowanego uzytkownika
  if (authenticatedUser) {
    //sprawdzamy czy uzytkownik ma podana akywnosc
    return authenticatedUser.roleIds.includes(userRole);
  }

  return false;

}

/**
 * Zwraca role zalogowanego uzytkonika
 * 
 * @param {object} authenticatedUser zalogowany uzytkownik
 * 
 */
export const getUserRoles = (authenticatedUser) => {

  //sprawdzamy czy mamy zalogowanego uzytkownika
  if (authenticatedUser) {
    //sprawdzamy czy uzytkownik ma podana akywnosc
    return authenticatedUser.roleIds;
  }

  //zwracamy pusta tablice jesli nie jest zalogowany
  return [];

}